import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import styles from '../../assets/jss/components/ListCustomLayoutSeminarAndLivestream';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import CustomTypography from '../Typography/CustomTypography';
import { ArrowDown, ArrowUp } from '../Icons/Icon';

const useStyles = makeStyles(styles);

const ListCustomLayout = ({
    title,
    time,
    textStatus,
    button,
    priceItem,
    speakerName,
    speakerProfile,
    urlImg,
    content,
    handleViewDetail,
    isViewDetail,
    customColor,
    date,
    isLiveStream,
}) => {
    const classes = useStyles({ customColor });
    const [isOpen, setIsOpen] = useState(false);
    const intl = useIntl();

    return (
        <>
            <GridContainer>
                <GridItem className={classes.listInfoEvent}>
                    <div className={classes.listTimeLeft}>
                        {date ? (
                            <CustomTypography
                                className={classes.listTimeLeftDate}
                                variant="h5"
                                color="event"
                                customColor={customColor?.event_name_text_color}
                            >
                                {date}
                            </CustomTypography>
                        ) : ''}
                        <CustomTypography
                            variant="h5"
                            color="event"
                            customColor={customColor?.event_name_text_color}
                        >
                            {time}
                        </CustomTypography>
                    </div>
                    {textStatus && (
                        <CustomTypography
                            className={classes.listStatusRight}
                            variant="h6"
                            customColor={customColor?.contents_text_color}
                        >
                            {textStatus}
                        </CustomTypography>
                    )}
                </GridItem>
            </GridContainer>
            <GridContainer>
                {button ? (
                    <>
                        <GridItem xs={12} sm={9} md={10} style={{ display: 'flex' }}>
                            <CustomTypography
                                variant="h6"
                                bold
                                customColor={customColor?.contents_text_color}
                                onClick={() => handleViewDetail()}
                                className={isViewDetail && classes.cursor}
                            >
                                {title}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={3} md={2} className={classes.listButton}>
                            {button}
                        </GridItem>
                    </>
                ) : (
                    <GridItem style={{ display: 'flex' }}>
                        <CustomTypography
                            variant="h6"
                            bold
                            onClick={() => handleViewDetail()}
                            customColor={customColor?.contents_text_color}
                            className={classNames({ [classes.cursor]: isViewDetail, [classes.paddingBottom]: true })}
                        >
                            {title}
                        </CustomTypography>
                    </GridItem>
                )}
            </GridContainer>
            <GridContainer className={classes.listProfile}>
                <GridItem xs={12} sm={9} md={9}>
                    {urlImg ? (
                        <GridContainer className={classes.listImgLeft}>
                            <GridItem xs={4} sm={3} md={3} lg={2}>
                                <div className={classes.listItemImg}>
                                    <img
                                        src={urlImg}
                                        alt=""
                                        className={classes.listImage}
                                    />
                                </div>
                            </GridItem>
                            <GridItem xs={8} sm={9} md={9} lg={10} className={classes.listProfileRight}>
                                <div>
                                    <CustomTypography
                                        className={classes.listProfileName}
                                        customColor={customColor?.contents_text_color}
                                    >
                                        {speakerName}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.listProfileSpeaker}
                                        customColor={customColor?.contents_text_color}
                                    >
                                        {speakerProfile}
                                    </CustomTypography>
                                </div>
                            </GridItem>
                        </GridContainer>
                    ) : (
                        <>
                            <CustomTypography
                                className={classes.listFullName}
                                customColor={customColor?.contents_text_color}
                            >
                                {speakerName}
                            </CustomTypography>
                            <CustomTypography
                                className={classes.listProfileSpeaker}
                                customColor={customColor?.contents_text_color}
                            >
                                {speakerProfile}
                            </CustomTypography>
                        </>
                    )}
                </GridItem>
                <GridItem xs={12} sm={3} md={3} className={classes.listPriceRight}>
                    <CustomTypography
                        className={classes.listPrice}
                        variant="h6"
                        customColor={customColor?.contents_text_color}
                    >
                        {priceItem}
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            {
                isOpen && (
                    <GridContainer className={classes.listContent}>
                        <GridItem>
                            <CustomTypography customColor={customColor?.contents_text_color}>
                                {content}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )
            }
            <GridContainer className={classes.listReadMore}>
                <p className={classes.listReadMoreButton} onClick={() => setIsOpen(!isOpen)}>
                    <CustomTypography
                        bold
                        color="navy"
                        customColor={customColor?.screen_name_text_color}
                    >
                        {!isOpen ? intl.formatMessage({ id: isLiveStream ? 'livestream.viewDetail' : 'seminar.viewDetail' }) : intl.formatMessage({ id: 'common.close' })}
                    </CustomTypography>
                    {isOpen ? (
                        <ArrowUp color={customColor?.screen_name_text_color || '#001d83'} size="20px" />
                    ) : (
                        <ArrowDown color={customColor?.screen_name_text_color || '#001d83'} size="20px" />
                    )}
                </p>
            </GridContainer>
            <Divider className={classes.dividerDown} />
        </>
    );
};

ListCustomLayout.defaultProps = {
    title: '',
    time: '',
    date: '',
    textStatus: '',
    button: undefined,
    priceItem: '',
    speakerName: '',
    speakerProfile: '',
    urlImg: '',
    content: '',
    handleViewDetail: () => {},
    isViewDetail: true,
    customColor: {},
    isLiveStream: false,
};

ListCustomLayout.propTypes = {
    title: PropTypes.string,
    time: PropTypes.string,
    date: PropTypes.string,
    textStatus: PropTypes.string,
    button: PropTypes.node,
    priceItem: PropTypes.string,
    speakerName: PropTypes.string,
    speakerProfile: PropTypes.string,
    urlImg: PropTypes.string,
    content: PropTypes.string,
    handleViewDetail: PropTypes.func,
    isViewDetail: PropTypes.bool,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLiveStream: PropTypes.bool,
};

export default ListCustomLayout;
